import { CloseOutlined } from '@ant-design/icons';
import { Button, Divider, Flex, Input, Modal, Select, Spin } from 'antd';
import React from 'react';
import Dialogue from '~/components/shared/Dialogue/Dialogue';
import { useCreateConversationWizard } from '~/hooks/useCreateConversationWizard';

import ConversationOrderSummary from '../../ConversationsList/ConversationDetails/ConversationOrderSummary/ConversationOrderSummary';
import CreateConversationForm from './CreateConversationForm';

function ConfirmQuitModal({ open, onCancel, onConfirm }) {
  return (
    <Modal open={open} closeIcon={null} footer={null} maskClosable={false} centered>
      <Flex vertical gap={32}>
        <Flex vertical gap={16}>
          <p className='h2'>Êtes-vous sûr·e de vouloir quitter votre brouillon ?</p>
          <p className='body1'>Il sera supprimé après confirmation.</p>
        </Flex>
        <Flex gap={8} align='center'>
          <Button onClick={onCancel} type='link' className='grow'>
            Annuler
          </Button>
          <Button type='primary' danger onClick={onConfirm} className='grow'>
            Supprimer le brouillon
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
}

function CreateConversationModal({ setSelectedConversation, baseOrderIdNumber = '', customText = null }) {
  const wizard = useCreateConversationWizard(baseOrderIdNumber);

  return (
    <>
      <Button onClick={wizard.openModal}>{customText || 'Nouveau message'}</Button>
      <Modal centered open={wizard.isModalOpen} onCancel={wizard.closeModal} footer={null} closeIcon={null} classNames={{ content: '!p-0' }} width={750}>
        <Flex vertical>
          <Flex className='py-s px-m' justify='space-between' align='center' gap={8}>
            <h2 className='h2'>Nouveau message</h2>
            <Button onClick={wizard.closeModal} type='link' className='btn-icon'>
              <CloseOutlined />
            </Button>
          </Flex>
          <Divider />
          <Flex className='p-m' vertical gap={16}>
            <Flex gap={16} align='center'>
              <Flex vertical gap={8}>
                <p className='caption2'>N° de commande</p>
                <Input
                  placeholder='241216E111873427'
                  defaultValue={baseOrderIdNumber}
                  value={wizard.orderNumber}
                  onChange={(e) => wizard.setOrderNumber(e.target.value)}
                  onPressEnter={(e) => wizard.setOrderNumber(e.target.value)}
                />
              </Flex>
              <ul className='list-disc body1 text-grey-medium ml-m'>
                <li>Collez le numéro de commande auquel associer la conversation.</li>
                <li>Vérifiez que c'est le bon destinataire.</li>
              </ul>
            </Flex>
            {wizard.showPartialOrderWarning && <Dialogue type='error' light message='Copiez puis collez le n° de commande ici pour éviter les erreurs.' />}
            {wizard.isError && <Dialogue type='info' light message="Nous n'avons pas trouvé de commande correspondante." />}
            {wizard.isLoading && (
              <Flex justify='center' align='center' className='grow py-m'>
                <Spin />
              </Flex>
            )}
            {wizard.order && (
              <>
                <div className='p-m rounded-sm bg-background'>
                  <ConversationOrderSummary order={wizard.order} merchant={wizard.order.merchant} user={wizard.order.user} />
                </div>
                <Flex vertical gap={8}>
                  <p className='caption2'>Motif de contact</p>
                  <Select
                    placeholder='Sélectionnez un motif'
                    value={wizard.contactReason}
                    onChange={wizard.setContactReason}
                    loading={wizard.isLoadingReasons}
                    options={wizard.contactReasons?.map((r) => ({ value: r.value, label: r.label }))}
                    className='w-full'
                  />
                </Flex>
                <CreateConversationForm
                  orderId={wizard.order.id}
                  closeModal={wizard.confirmQuit}
                  setSelectedConversation={setSelectedConversation}
                  contactReason={wizard.contactReason}
                />
              </>
            )}
          </Flex>
        </Flex>
      </Modal>
      <ConfirmQuitModal open={wizard.showConfirmQuitModal} onCancel={wizard.dismissConfirmQuit} onConfirm={wizard.confirmQuit} />
    </>
  );
}

export default CreateConversationModal;
